import { useSiteTheme } from 'components/SiteTheme';
import usePaperworkTheme from 'components/paperwork/usePaperworkTheme';
import SiteThemeControl from 'components/SiteThemeControl';
import './ServicesExperience.css';

export default function ServicesTheme({ children }) {
  const shared = useSiteTheme();
  const { preference, theme, select } = usePaperworkTheme('services');
  return <div className="services-experience" data-theme={theme}>
    {!shared && <SiteThemeControl preference={preference} select={select} />}
    {children}
  </div>;
}
